import {  useState } from "react";
import { useRecoilState } from "recoil";
import { Button,  Input, Modal, SreenCoverLoading } from "src/components";
import { recoilStates } from "src/recoil/recoilStates";

import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAlert } from "src/hooks";
import { colors } from "../styles/theme";
import { FaArrowDownLong } from "react-icons/fa6";
import { IoCopySharp } from "react-icons/io5";
import copyToClipboard from "../utils/copyToClipboard";
import { createTeeshotAxiosInstance } from "../http";

const DEFAULT_PCD = "event-fee";
export default function EventPayments() {
  const navigate = useNavigate();
  const [eventApplication] = useRecoilState(recoilStates.eventApplication);
  const teamAmount = eventApplication?.team_amount || 0;
  const targetRel = eventApplication?.event_booking_rel_club?.find((r) => r.status_id === 5);
  const deposit = targetRel?.deposit || 0;
  const alert = useAlert();
  const fee = teamAmount * 20000;

  const handleCallKgCard = (itemCodeInsert?: string) => {
    if (!itemCodeInsert) {
      itemCodeInsert = DEFAULT_PCD;
    }
    (async () => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_TEESHOT_SERVER_URL}/kgMob/credit/callPaymentWindow?callType=I`,
          {
            token: localStorage?.getItem("auth-token"),
            itemCode: itemCodeInsert ?? "",
            paymentEndBackUrl: `${process.env.REACT_APP_DOMAIN}/event-booking`,
            cancelUrl: `${process.env.REACT_APP_TEESHOT_SERVER_URL}/kgMob/cancel`,
            additionalNoti: {
              key: "eventBooking",
              param: { bookingId: eventApplication?.id, itemCodeInsert: itemCodeInsert },
            },
          }
        );
        if (!res.data.success) {
          throw new Error(res?.data?.message || "결제 불러오기 오류");
        }

        // await refetchBookings();
        navigate("/kgController", { state: { htmlToShow: res.data.data } });
        // window.location.reload();
      } catch (e: any) {
        alert(e.message || "오류발생");
        console.log("e :", e);
      }
    })();
  };
  const [isChecked, setIsChecked] = useState(false);
  const teeshotAccountNumber = "1005-202-583312";
  const { onChange: onBankChange, value: bankValue } = Input.hooks.useInput(
    eventApplication?.refund_account_bank_name || ""
  );
  const { onChange: onNameChange, value: nameValue } = Input.hooks.useInput(
    eventApplication?.refund_account_depositor_name || ""
  );
  const { onChange: onAccountChagne, value: accontValue } = Input.hooks.useInput(
    eventApplication?.refund_account_number || ""
  );
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  return (
    <>
      {isLoading && <SreenCoverLoading />}
      {isModalOpened && (
        <Modal
          btnType="confirm-cancel"
          rejectConfirmCondition={!Boolean(bankValue && nameValue && accontValue)}
          rejectConfirmMsg="계좌 정보를 모두 입력하세요."
          onConfirm={async () => {
            setIsLoading(true);
            try {
              const res = await createTeeshotAxiosInstance().post(
                "/evtBooking/booking/addRefundBank",
                {
                  eventBookingId: eventApplication?.id,
                  accountNumber: accontValue,
                  bankName: bankValue,
                  depositor: nameValue,
                }
              );
              if (!res.data.success) {
                throw new Error(res.data.message);
              }
              setIsLoading(false);
              alert("계좌 등록성공");
            } catch (e: any) {
              setIsLoading(false);

              alert(e.message || "오류발생");
              console.log("e :", e);
            }

            // await sleep(1000);
          }}
          content={
            <>
              <div className="d-flex fd-c gap-1">
                <Input
                  attr={{
                    placeholder: "은행명",
                    onChange: (e) => {
                      console.log("e :", e);

                      onBankChange(e);
                    },
                    value: bankValue,
                  }}
                />
                <Input
                  attr={{
                    placeholder: "계좌번호",
                    onChange: onAccountChagne,
                    value: accontValue,
                  }}
                />
                <Input
                  attr={{
                    placeholder: "예금주",
                    onChange: onNameChange,
                    value: nameValue,
                  }}
                />
              </div>
            </>
          }
          title="환불계좌 등록"
          setModalState={setIsModalOpened}
        />
      )}
      <Container className="flex-1 d-flex fd-c gap-1">
        <section className="reciept">
          <div className="d-flex jc-sb line">
            <div>이용수수료</div>
            <div>{fee.toLocaleString()} 원</div>
          </div>
          <div className="d-flex jc-sb line">
            <div>
              보증금 <span className="fc-red">(환불)</span>
            </div>
            <div className="d-flex fd-c ai-e">
              <div>{deposit.toLocaleString()} 원</div>
            </div>
          </div>
          <div className="fs-2 bold d-flex jc-e">* 골프장 상황에 따라 달라질수 있음</div>

          <div className="d-flex jc-sb sum-box line">
            <div>결제금액</div>
            <div>{(fee + deposit).toLocaleString()} 원</div>
          </div>
        </section>

        <div className="d-flex jc-sb ai-c">
          <div className="bold">입금계좌</div>
          <div>
            <Button
              $colorTheme="lightGray2"
              className="pd-2"
              $round
              $buttonSize="sm"
              $outline
              onClick={() => {
                setIsModalOpened(true);
              }}
            >
              환불계좌 등록
            </Button>
          </div>
        </div>

        <div className="deposit-card d-flex fd-c gap-1">
          <div className="d-flex jc-sb">
            <div className="blue">우리은행</div>
            <div>{teeshotAccountNumber}</div>
          </div>
          <div className="d-flex jc-sb">
            <div className="gray">예금주</div>
            <div>(주)에이치비엠피</div>
          </div>
          <div className="d-flex jc-sb">
            <div className="gray">보내는 사람</div>
            <div className="y-b">홍길동1234</div>
          </div>
          <div className="as-e">
            <FaArrowDownLong color="red" />
          </div>
          <div className="as-e desc">
            가입자 실명 + 휴대전화 <span className="blue">뒤 4자리</span>
          </div>
        </div>

        <Button
          $colorTheme="green"
          className="d-flex gap-1"
          onClick={async () => {
            await copyToClipboard(teeshotAccountNumber);
            alert("복사되었습니다.");
          }}
        >
          계좌번호 복사하기 <IoCopySharp />
        </Button>
        <div className="flex-1" />

        <div className="d-flex gap-1 ai-s">
          <input
            type="checkbox"
            className="mt-1"
            checked={isChecked}
            onChange={() => setIsChecked((b) => !b)}
            // for="aa"
            id="checkAgreeFee"
          />
          <label htmlFor="checkAgreeFee">티샷 예약조건을 확인하고 이에 동의 합니다.</label>
        </div>
        <div className="bot-desc page-pd-negative-all d-flex fd-c gap-2 fs-3">
          <div>
            ▶ 이용수수료는 팀당 2만원이며, 보증금은 라운드후 3영업일내에 환불계좌로 입금됩니다.
          </div>
          <div>
            ▶ 본 이용수수료는 결제일로부터 7일 이내 청약 철회가 가능하고, 결제일 포함 7일 경과
            후에는 환불이 불가합니다.
          </div>
          <div>▶ 7일 이내 환불 요청시, 부킹서비스 예약이 취소됩니다.</div>
        </div>
      </Container>
    </>
  );
}

const Container = styled.div`
  .reciept {
    > .line {
      padding: 5px;
      font-weight: bold;
    }
    .sum-box {
      background-color: ${colors.gray.first};
      color: white;
    }
    margin-bottom: 30px;
  }
  .deposit-card {
    /* border: 1px solid black; */

    padding: 10px;
    font-weight: bold;
    .y-b {
      background-color: ${colors.yellow.first};
    }
    .gray {
      color: ${colors.gray.first};
    }
    .desc {
      margin-top: -10px;
    }
    .blue {
      color: ${colors.blue.third};
    }
  }

  .bot-desc {
    background-color: ${colors.gray.third};
    margin-top: 0px !important;
    padding: 15px;
  }
`;
